import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  CircularProgress,
  Icon,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@material-ui/core";
import { red, green } from "@material-ui/core/colors";
import {
  MoreVert as MoreVertIcon,
  CheckCircle,
  Cancel,
} from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import React, { useCallback, useEffect, useState } from "react";
import {
  getAllMarketingCampaigns,
  changeStatus,
} from "../../api/marketingService";
import ConfirmDeleteCampaign from "./ConfirmDeleteCampaign";
import MarketingCampaignForm from "./MarketingCampaignForm";

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr 1fr",
    gap: 10,
  },
  availabilityIcon: {
    color: green[500],
  },
  unavailabilityIcon: {
    color: red[500],
  },
}));

const MarketingCampaignsScreen = () => {
  const classes = useStyles();
  const [selectedId, setSelectedId] = useState(null);
  const [openedDialog, setOpenedDialog] = useState(false);
  const [openedDeleteDialog, setOpenedDeleteDialog] = useState(false);
  const [searching, setSearching] = useState(false);
  const [campaigns, setCampaigns] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  function handleClose() {
    setAnchorEl(null);
  }

  const handleClick = (event, campaignId) => {
    setAnchorEl(event.currentTarget);
    setSelectedId(campaignId);
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const newStatus = !currentStatus;
    try {
      await changeStatus(id, newStatus);
      buscarDados(); // Atualiza a lista de campanhas após a alteração de status
    } catch (error) {
      // Lida com o erro caso ocorra
      console.error(error);
    }
  };

  const buscarDados = useCallback(async () => {
    setSearching(true);
    const response = await getAllMarketingCampaigns();
    setCampaigns(response);
    setSearching(false);
  }, []);

  useEffect(() => {
    buscarDados();
  }, [buscarDados]);

  return (
    <Box style={{ margin: 10 }}>
      <MarketingCampaignForm
        id={selectedId}
        open={openedDialog}
        onClose={() => {
          setOpenedDialog(false);
          setSelectedId(undefined);
          buscarDados();
        }}
      />

      <ConfirmDeleteCampaign
        id={selectedId}
        open={openedDeleteDialog}
        onClose={() => {
          setOpenedDeleteDialog(false);
          setSelectedId(undefined);
          buscarDados();
        }}
      />

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h4">Marketing Campaigns</Typography>
        <Button
          color="secondary"
          variant="contained"
          onClick={() => setOpenedDialog(true)}
        >
          <Icon style={{ marginRight: 10 }}>add</Icon> Create Marketing Campaign
        </Button>
      </div>
      {searching && <CircularProgress />}
      <Box className={[classes.card, classes.grid]} marginTop="30px">
        {campaigns?.map((campaign) => (
          <Card key={`campaign-${campaign.id}`} className={classes.card}>
            <CardHeader
              avatar={
                <Avatar aria-label="Campaign name" className={classes.avatar}>
                  {campaign.name[0].toUpperCase()}
                </Avatar>
              }
              action={
                <>
                  {campaign.status ? (
                    <CheckCircle className={classes.availabilityIcon} />
                  ) : (
                    <Cancel className={classes.unavailabilityIcon} />
                  )}
                  <IconButton
                    aria-label="Options"
                    onClick={(event) => handleClick(event, campaign.id)} // Passa o id da campanha para handleClick
                    data-id={campaign.id}
                  >
                    <MoreVertIcon />
                  </IconButton>
                </>
              }
              title={campaign.name}
              subheader={`by ${campaign.companyName}`}
            />
            <CardMedia
              className={classes.media}
              image={campaign.banners[0]}
              title={`Banner ${campaign.name}`}
            />
            <CardContent>
              <Typography variant="body2" color="textSecondary" component="p">
                {campaign.description}
              </Typography>
            </CardContent>
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={(evt) => {
                  const id = selectedId;
                  handleToggleStatus(id, campaign.status);
                  handleClose();
                }}
              >
                {campaigns.find((campaign) => campaign.id === selectedId)
                  ?.status
                  ? "Disable"
                  : "Activate"}
              </MenuItem>
              <MenuItem
                onClick={(evt) => {
                  const id = anchorEl.dataset.id;
                  setSelectedId(id);
                  setOpenedDialog(true);
                  handleClose();
                }}
              >
                Edit
              </MenuItem>
              <MenuItem
                onClick={(evt) => {
                  const id = anchorEl.dataset.id;
                  setSelectedId(id);
                  setOpenedDeleteDialog(true);
                  handleClose();
                }}
              >
                Delete
              </MenuItem>
            </Menu>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default MarketingCampaignsScreen;
